module.exports = __webpack_public_path__ + "static/media/ea.a3dde959.png";